/** Match server `amountPaiseAfterVoucherPercent` for display. */
export function amountPaiseAfterVoucherPercent(basePaise, percentOff) {
  const base = Math.max(0, Math.round(Number(basePaise) || 0));
  const pct = Math.min(100, Math.max(0, Math.round(Number(percentOff) || 0)));
  if (pct <= 0) return base;
  if (pct >= 100) return 0;
  const off = Math.round((base * pct) / 100);
  return Math.max(0, base - off);
}
